module.exports = __webpack_public_path__ + "img/SpatialAudioOffOutlined.2f9e00bf.svg";